/** Authentication group (canonical `bC9Cyzeq`, spec §3). */

import { api } from "./client";
import type { LoginResponse, User } from "@/types";

/** POST auth/login — issues a token to any valid user (incl. role:client). */
export function login(email: string, password: string): Promise<LoginResponse> {
  return api.post<LoginResponse>("auth", "auth/login", {
    body: { email, password },
    auth: false,
  });
}

/** GET auth/me — returns the user record incl. role. Requires the bearer token.
 *  Gate the staff console on a console role — admin or staff (spec §3) — do not
 *  rely on the server gate alone for UX. */
export function me(): Promise<User> {
  return api.get<User>("auth", "auth/me", { auth: true });
}
